import logo from './logo.svg';
import './App.css';

import { Graph } from './graph_client/Graph'
import { UploadFile } from './Components/FileUpload'

const App = () => {
  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <p>
          For Alex!!!
        </p>
        <Graph>
          <UploadFile />
        </Graph>
        <a
          className="App-link"
          href="https://reactjs.org"
          target="_blank"
          rel="noopener noreferrer"
        >
          Learn React
        </a>
      </header>
    </div>
  );
}

export default App;
